export const Navlink=[
    {
        id:1,
        name:"About us"
    },
    {
        id:2,
        name:"Product & Services"
    },
    {
        id:3,
        name:"Partner with us"
    },
    {
        id:4,
        name:"Tm Bank Account Details"
    },
    {
        id:5,
        name:"PlatForms"
    },
    {
        id:6,
        name:"Education"
    },
    {
        id:1,
        name:"Contact us"
    }
]